<template>
  <div class="app-header bg-app-header">
    <div class="flex p2">
      <div>
        <a class="btn p0" @click.stop="home()">
          <i class="material-icons">
            home
          </i>
          {{title}}
        </a>
      </div>
      <div class="flex-auto">
        <div v-if="$route.params.idaluno !== $auth.user.id" class="px1 right">
          <h3 class="m0">{{$dados.ALUNO.EMAIL}}</h3>
        </div>
      </div>
      <div v-if="$auth.logged" class="relative">
        <button class="circle p0 btn bg-white black" @click.stop="$emit('update:showUserMenu', !showUserMenu)">
          <i class="material-icons">person</i>
        </button>
        <div v-show="showUserMenu" class="absolute top-4 right-0 bg-black white" @click.stop>
          <ul class="list-reset">
            <li class="px2 my2">
              <span class="">
                {{$auth.user.email}} <span v-if="$auth.user.role">({{$auth.user.role}})</span>
              </span>
              <hr/>
            </li>
            <li class="px2 my2">
              <span class="btn" @click="$auth.dialog.loginChange.show();$emit('update:showUserMenu', false)">
                Alterar senha
              </span>
            </li>
            <li class="px2 my2">
              <span class="btn" @click="$faleConosco.show();$emit('update:showUserMenu', false)">
                Fale conosco
              </span>
            </li>
            <li class="px2 my2" v-if="$auth.user.role == 'admin'">
              <span class="btn" @click="usarcomo();$emit('update:showUserMenu', false)">
                Usar como
              </span>
            </li>
            <li class="px2 my2">
              <span class="btn" @click="$auth.logout()">
                Sair
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['showUserMenu'],
  computed: {
    title: function () {
      const title = []
      if (this.$route.path !== '/') {
        title.push(this.$route.meta.title)
      }
      title.push(this.$app.name)
      if (this.$app.instance.name) {
        title.push(this.$app.instance.name)
      }
      return title.join(' - ')
    }
  },
  methods: {
    home: function () {
      location.hash = '#/aluno/' + this.$auth.user.id
    },
    usarcomo: function () {
      location.hash = '#/aluno/' + this.$auth.user.id + '/usar-como'
    }
  }
}
</script>
